<script setup lang="ts">
import CanvasButton from "@/components/canvas/CanvasButton.vue";
import DraggerMenuState from "@/stores/DraggerMenuState";

function toggle() {
  DraggerMenuState.toggleSequentialPointMode();
}
</script>
<template>
  <CanvasButton
    @click.prevent.stop="toggle"
    :tooltipTitle="$t('canvas:tools.options.sequential.tooltip.title')"
    :tooltipText="$t('canvas:tools.options.sequential.tooltip.text')"
    :mode="DraggerMenuState.sequentialPointMode"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="16"
      height="16"
    >
      <!-- point A -->
      <circle cx="6" cy="24" r="3.5" fill="currentColor" />
      <!-- point B -->
      <circle
        cx="26"
        cy="8"
        r="3.5"
        fill="none"
        stroke="currentColor"
        stroke-width="2.5"
      />
      <!-- dashed path between the two points -->
      <path
        d="M9.5 21.5 L22.5 10.5"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-dasharray="3 3"
      />
    </svg>
  </CanvasButton>
</template>
